export default {
  intro: {
    logoText: 'mentorist',
    // Core promise: daily action-based mentoring, not book summaries
    slides: {
      // Single intro variant (formerly Variant C: Control Improved)
      control_improved: [
        {
          title: 'One clear next step — for you',
          subtitle: 'Mentorist helps you move through everyday struggles with do-first Steps grounded in the best books.',
          cta: 'Continue',
        },
        {
          title: 'Not ChatGPT. A mentor that remembers you.',
          subtitle: 'Adapts to your needs, considering your circumstances',
          cta: 'Continue',
        },
        {
          title: 'Small Steps. Real change.',
          subtitle: 'Books become the tool. Your mentor turns them into actions you can apply today.',
        },
      ],
    },
    threeStepModel: {
      step1: 'Tell your goal',
      step2: 'Mentor builds plan from books',
      step3: 'Get one clear step daily',
    },
    scrollHint: 'Scroll to see how it works',
    // Buttons shown on the last slide only
    buttons: {
      getStarted: 'Get Started',
      alreadyHaveAccount: 'I already have an account',
    },
    alerts: {
      pleaseWait: 'Please wait',
      initializing: 'Initializing...',
      error: 'Error',
      failedToInitialize: 'Failed to initialize. Please try again.',
    },
  },
  
  // NOTE: Page-Based Onboarding (Discovery V2) text is defined in screens/Onboarding/DiscoveryV2OnboardingScreen.tsx
  // The localPages array has a clean JSON structure with all questions and options inline.
  
  // Name Input Screen
  nameInputScreen: {
    greeting1: 'Hi! I\'m your new mentor. I was created to perfectly match your needs.',
    greeting2: 'Before we continue, tell me how should I call you?',
    placeholder: 'Your name',
  },
  
  // Profile Summary Screen
  profileSummary: {
    title: 'Your Growth Plan',
    labels: {
      name: 'Name',
      primaryFocus: 'Primary focus',
      focus: 'Focus',
      preferredMentors: 'Preferred mentors',
      guideStyle: 'Guide style',
      coreMotivation: 'Core motivation',
      mainMotivation: 'Main motivation',
      mainChallenge: 'Main challenge',
      biggestChallenge: 'Biggest challenge',
      learningStyle: 'Learning style',
      speedOfLearning: 'Speed of learning',
      keyStrength: 'Key strength',
      primaryGoal: 'Primary goal',
    },
    button: 'Start My Journey',
  },
  
  // Calculation/Processing Screen
  calculation: {
    initialThinking: 'Let me analyze all your responses and prepare a personalized plan for you...',
    loadingProfile: 'Loading your profile...',
    preparingExperience: 'Preparing your personalized experience...',
    
    progressSteps: {
      analyzingResponses: 'Analyzing your responses',
      identifyingInsights: 'Finding personalized actions for you',
      creatingProfile: 'Creating your mentor profile',
      creatingPlan: 'Creating your action plan',
    },
    
    errors: {
      somethingWentWrong: 'Something went wrong',
      tryAgain: 'Try Again',
    },
  },
  // Auth screens
  auth: {
    login: {
      title: 'Welcome Back',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      loginButton: 'Log In',
      forgotPassword: 'Forgot Password?',
      noAccount: "Don't have an account?",
      signUp: 'Sign Up',
    },
    signup: {
      title: 'Create Account',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      confirmPasswordPlaceholder: 'Confirm Password',
      signupButton: 'Sign Up',
      haveAccount: 'Already have an account?',
      login: 'Log In',
    },
  },
  // Dashboard
  dashboard: {
    home: {
      welcome: 'Welcome back',
      greeting: 'Hello, {{name}}',
      continueReading: 'Continue Reading',
      recommended: 'Recommended for You',
      explore: 'Explore',
    },
  },
  // Onboarding (placeholders for future migration)
  onboarding: {
    chat: {
      placeholder: 'Type your message...',
      send: 'Send',
    },
  },
  // Common/Shared
  common: {
    buttons: {
      next: 'Next',
      back: 'Back',
      continue: 'Continue',
      skip: 'Skip',
      done: 'Done',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      ok: 'OK',
      yes: 'Yes',
      no: 'No',
    },
    messages: {
      loading: 'Loading...',
      error: 'Something went wrong',
      success: 'Success!',
      noData: 'No data available',
      tryAgain: 'Try again',
    },
  },
};

